import React from 'react';


// Import SVG (use it as a component)
import { ReactComponent as MySVG } from '../pages/faxicon.svg';
function Gallery(){

    return (
        <div id="top">

        <section className="section event" id="event" aria-label="event">
    <div className="container">
      <div className="all-events-text">
        <h2>Gallery</h2>
      </div>
      <ul className="grid-list">
        <li>
            <div className="image-container">
              <figure className="card-banner1">
                <img src={require("./images/1.JPG" )}loading="lazy" alt="Innovation & Technological Entrepreneurship Team" className="img-cover"/>
              </figure>
            </div>
          </li>
          <li>
            <div className="image-container">
              <figure className="card-banner1">
                <img src={require("./images/2.JPG" )}loading="lazy" alt="Virtual Spring Part-time Jobs Fair for Student" className="img-cover"/>
              </figure>
            </div>
          </li>
          <li>
            <div className="image-container">
              <figure className="card-banner1">
                <img src={require("./images/3.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
              </figure>
            </div>
          </li>
          <li>
            <div className="image-container">
              <figure className="card-banner1">
                <img src={require("./images/4.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
              </figure>
            </div>
          </li>
          <li>
            <div className="image-container">
              <figure className="card-banner1">
                <img src={require("./images/5.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
              </figure>
            </div>
          </li>
          <li>
            <div className="image-container">
              <figure className="card-banner1">
                <img src={require("./images/6.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
              </figure>
            </div>
          </li>
          <li>
              <div className="image-container">
                <figure className="card-banner1">
                  <img src={require("./images/7.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                </figure>
              </div>
            </li>
            <li>
              <div className="image-container">
                <figure className="card-banner1">
                  <img src={require("./images/8.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                </figure>
              </div>
            </li>
            <li>
              <div className="image-container">
                <figure className="card-banner1">
                  <img src={require("./images/9.JPG" )}loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                </figure>
              </div>
            </li>
            <li>
              <div className="image-container">
                <figure className="card-banner1">
                  <img src={require("./images/10.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                </figure>
              </div>
            </li>
            <li>
              <div className="image-container">
                <figure className="card-banner1">
                  <img src={require("./images/11.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                </figure>
              </div>
            </li>
            <li>
              <div className="image-container">
                <figure className="card-banner1">
                  <img src={require("./images/12.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                </figure>
              </div>
            </li> 
            <li>
                <div className="image-container">
                  <figure className="card-banner1">
                    <img src={require("./images/13.JPG")} loading="lazy" alt="Innovation & Technological Entrepreneurship Team" className="img-cover"/>
                  </figure>
                </div>
              </li>
              <li>
                <div className="image-container">
                  <figure className="card-banner1">
                    <img src={require("./images/14.JPG")} loading="lazy" alt="Virtual Spring Part-time Jobs Fair for Student" className="img-cover"/>
                  </figure>
                </div>
              </li>
              <li>
                <div className="image-container">
                  <figure className="card-banner1">
                    <img src={require("./images/15.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                  </figure>
                </div>
              </li>
              <li>
                <div className="image-container">
                  <figure className="card-banner1">
                    <img src={require("./images/16.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                  </figure>
                </div>
              </li>
              <li>
                <div className="image-container">
                  <figure className="card-banner1">
                    <img src={require("./images/17.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                  </figure>
                </div>
              </li>
              <li>
                <div className="image-container">
                  <figure className="card-banner1">
                    <img src={require("./images/18.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                  </figure>
                </div>
              </li>
              <li>
                  <div className="image-container">
                    <figure className="card-banner1">
                      <img src={require("./images/19.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                    </figure>
                  </div>
                </li>
                <li>
                  <div className="image-container">
                    <figure className="card-banner1">
                      <img src={require("./images/20.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                    </figure>
                  </div>
                </li>
                <li>
                  <div className="image-container">
                    <figure className="card-banner1">
                      <img src={require("./images/21.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                    </figure>
                  </div>
                </li>
                <li>
                  <div className="image-container">
                    <figure className="card-banner1">
                      <img src={require("./images/22.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                    </figure>
                  </div>
                </li>
                <li>
                  <div className="image-container">
                    <figure className="card-banner1">
                      <img src={require("./images/23.JPG")} loading="lazy" alt="Explorations of Regional Chief Executive Network" className="img-cover"/>
                    </figure>
                  </div>
                </li>
                
                  
      </ul>
    </div>
  </section>






  <a href="#top" className="back-top-btn" aria-label="Back to top" data-back-top-btn>
    <ion-icon name="arrow-up"></ion-icon>
  </a>



</div>
    
    );
    }

export default Gallery;